import styled from 'styled-components';
import { ScreenSize } from '../../../../enums';

export const FilterWrapper = styled.div`
	padding: 10px 0;
`;
